import { Button, ClickAwayListener, Link, Paper, Popper, Stack, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import LookerIcon from '../../assets/lookericon.svg?react';

interface LookerLinkProps {
  contractId?: number;
  adGroupId?: number;
  lineItemId?: number;
}

function LookerLink({ contractId, lineItemId, adGroupId }: LookerLinkProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const togglePopper = (e) => {
    e.stopPropagation();
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.target);
    }
  };

  if (!adGroupId && !lineItemId && !contractId) {
    return null;
  }

  return (
    <Stack sx={{ color: 'gray' }}>
      <Tooltip title="Looker" placement="top-end">
        <LookerIcon height="30" width="25" onClick={togglePopper} />
      </Tooltip>
      <Popper
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        placement="bottom-start"
        onClick={(e) => e.stopPropagation()}
        sx={{ zIndex: 10 }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <div>
            <Paper sx={{ p: 2 }}>
              <Stack>
                {contractId && (
                  <>
                    <Link
                      href={`//thinknear.looker.com/dashboards-next/bidder_metrics_bigquery::campaign_analysis?Contract+ID+Filter=${contractId}&IO+ID+Filter=&Campaign+ID+Filter=&Partition=1+day+ago+for+1+day&Table+Metric=Impressions&Graph+Scale=Hour`}
                      target="_blank"
                    >
                      <Button>Contract Analysis</Button>
                    </Link>
                    <Link
                      href={`//thinknear.looker.com/dashboards/bidder_metrics_bigquery::event_streaming?time_range=60+minutes&time_agg=Minute&contract_id=${contractId}&insertion_order_id=&campaign_id=`}
                      target="_blank"
                    >
                      <Button>Event Streaming</Button>
                    </Link>
                  </>
                )}
                {lineItemId && (
                  <>
                    <Link
                      href={`//thinknear.looker.com/dashboards-next/bidder_metrics_bigquery::campaign_analysis?Contract+ID+Filter=&IO+ID+Filter=${lineItemId}&Campaign+ID+Filter=&Partition=1+day+ago+for+1+day&Table+Metric=Impressions&Graph+Scale=Hour`}
                      target="_blank"
                    >
                      <Button>Line Item Analysis</Button>
                    </Link>
                    <Link
                      href={`//thinknear.looker.com/dashboards/bidder_metrics_bigquery::event_streaming?time_range=60+minutes&time_agg=Minute&contract_id=&insertion_order_id=${lineItemId}&campaign_id=`}
                      target="_blank"
                    >
                      <Button>Event Streaming</Button>
                    </Link>
                  </>
                )}
                {adGroupId && (
                  <>
                    <Link
                      href={`//thinknear.looker.com/dashboards-next/bidder_metrics_bigquery::campaign_analysis?Contract+ID+Filter=&IO+ID+Filter=&Campaign+ID+Filter=${adGroupId}&Partition=1+day+ago+for+1+day&Table+Metric=Impressions&Graph+Scale=Hour`}
                      target="_blank"
                    >
                      <Button>Campaign Analysis</Button>
                    </Link>
                    <Link
                      href={`//thinknear.looker.com/dashboards/bidder_metrics_bigquery::event_streaming?time_range=60+minutes&time_agg=Minute&contract_id=&insertion_order_id=&campaign_id=${adGroupId}`}
                      target="_blank"
                    >
                      <Button>Event Streaming</Button>
                    </Link>
                  </>
                )}
              </Stack>
            </Paper>
          </div>
        </ClickAwayListener>
      </Popper>
    </Stack>
  );
}

export default LookerLink;
